import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import '../css/cheerup.css';
import Bg from '../images/Event/cheerup/bg.png';

class EventCheerup extends Component {
  constructor(props) {
    super(props);

    this.state = {
      scrollTop: 0
    };
  }

  componentDidMount() {
    window.pageVisit("cheerup", "2009");
    window.addEventListener("scroll", this.onScroll);
  }

  onScroll = (e) => {
    const scrollTop = ("scroll", e.srcElement.scrollingElement.scrollTop);
    this.setState({scrollTop: scrollTop});
  }

  render() {
    return (
      <Fragment>
        <div id="skipNavi">
          <h1 className="blind">TOZ StudyCenter 스킵네비게이션</h1>
          <ul>
            <li><a href="#contents" className="skipLink">본문바로가기</a></li>
            <li><a href="#topmenu" className="skipLink">주메뉴바로가기</a></li>
          </ul>
        </div>
        <div id="doc" className="isPage">	
          <div id="pg-code" className="doc-pg">
            <div id="container-wrap"  className="div-cont cheerup" style={{background: '#fff'}}>
              <div id="contents" style={{background: '#fff'}}>
                <img src={Bg} style={{width: '100%'}} />
              </div>
              <Link to="/event/branch/89" className={`banner ${this.state.scrollTop > 500 ? "show" : ""}`} onClick={() => window.pageComplete("cheerup", "2009")}></Link>
            </div>
          </div>
        </div>
      </Fragment>
    )
  }
}

export default EventCheerup;
